// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3trEY","alert":"SettungsInbox_alert__3RVxF"};